import { FileClient, PageableResponse, RestClient } from "..";

export type B040030FindRequest = Partial<{
  hachuYmdFrom: string;
  hachuYmdTo: string;
  nyukayoteiYmdFrom: string;
  nyukayoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  hachudenpyoNoFrom: string;
  hachudenpyoNoTo: string;
  shireCd: string;
  sokoCd: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  shohinCd: string;
  kanryoKbn: string;
  janCd: string;
  shohinshubetsuKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B040030FindResponse = {
  uchiwakeNmr: string;
  hachuYmd: string;
  nyukayoteiYmd: string;
  hachudenpyoNo: string;
  hachudenpyoNoF: string;
  shohinCd: string;
  shohinNm: string;
  hachusu: string;
  shiresu: string;
  hachuzansu: string;
  hachuKin: string;
  hachuzanKin: string;
  sokoCd: string;
  sokoNm: string;
  shireNm: string;
  shainNm: string;
  bumonNmr: string;
  kanryoKbnView: string;
};

// 検索メソッド
export const B040030Find = (props: B040030FindRequest) => {
  return RestClient.get<PageableResponse<B040030FindResponse>>("b040030/find", {
    params: props,
  });
};

// 発注明細データExcel出力メソッド
export const B040030GetExcel = (props: B040030FindRequest) => {
  return FileClient.get("b040030/get/excel", {
    params: props,
  });
};
